import useFlexBoxStyles from 'common/flexBox';
import getVideoRect from 'common/utils/getVideoRect';
import { useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    highlight: {
        border: `solid 4px ${theme.palette.common.green}`,
    },
    rightPosition: {
        transform: `rotate(-90deg)`,
        bottom: '80px',
        right: '-105px',
    },
    leftPosition: {
        transform: `rotate(-90deg)`,
        top: '80px',
        left: '-105px',
    },
    fontColor: {
        color: theme.palette.background.paper,
    },
    topM2: {
        top: theme.spacing(-0.25),
    },
}));

const CustomMobileFitHighlight = ({ video }) => {

    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();
    const [div, setDiv] = useState(null);

    let mobileViewport;
    let videoRect;
    let mobileRect;

    if (div && video?.width && video?.height) {
        const divRect = div.getBoundingClientRect();
        videoRect = getVideoRect(divRect, video);
        mobileRect = {
            width:
                videoRect.height /
                (!isMobile || isTablet || divRect.width < divRect.height
                    ? 1.7
                    : divRect.width < 700
                    ? 3
                    : divRect.width / divRect.height),
            height: '100%',
        };
        videoRect.left = (divRect.width - videoRect.width) / 2;
        videoRect.top = (divRect.height - videoRect.height) / 2;

        mobileViewport = (
            <div
                style={{ ...mobileRect }}
                className={cx(classes.highlight, flexBox.relative, 'contain', flexBox.borderBox)}
            ></div>
        );
    }

    return (
        <div
            id="onlive-mobile-fit"
            ref={setDiv}
            className={cx(
                flexBox.absolute,
                classes.topM2,
                flexBox.left0,
                flexBox.w100,
                flexBox.h100,
                flexBox.flex,
                flexBox.alignItemsCenter,
                flexBox.justifyContentCenter,
                flexBox.zIndex1,
            )}
        >
            {mobileViewport}
        </div>
    );
};

export default CustomMobileFitHighlight;
